export default __webpack_public_path__ + "static/lock-blaster-7b21849806d54dd1b04453f6407e3095.svg";